<template>
  <MessageLayout
    image="./email-sent.svg"
    title="Finish your Nobl9 Registration"
    :need-help="false"
  >
    You already started your Nobl9 registration process. Check your mailbox and
    follow the instructions in the verification email to finish creating your
    Nobl9 account. If you didn’t receive the email, check the junk folder or
    <a :href="configService.supportUrl">contact Nobl9 Support</a>.
  </MessageLayout>
</template>

<script lang="ts" setup>
import { configService } from "@/services/config-service";
import MessageLayout from "@/modules/messages/MessageLayout.vue";
</script>
